import humps from 'humps'
import { defineStore } from 'pinia'
import { readonly, computed } from 'vue'
import { useNuxtApp } from '@nuxt/bridge/dist/runtime'
import { useExtensionMaster } from './useExtensionMaster'
import { useMemoriaMaster } from './useMemoriaMaster'
import { useHeroMaster } from './useHeroMaster'
import { useConsumableMaster } from './useConsumableMaster'
import UnitSummonItem from '@/static/unitSummonItem.json'
import constants from '@/assets/constants.json'

export const useRewardStore = defineStore('rewardStore', () => {
  // getters
  const getReward = computed(() => (i: any) => {
    const { $env } = useNuxtApp()
    let type = i.type || i.itemType
    let id = i.id || i.itemId
    let item = null

    //- スフィア
    if (type == 100) {
      item = useExtensionMaster().getExtensionType(id)
      //- インゴット
    } else if (type == 200) {
      item = useConsumableMaster().getExpItem(id)
      if (item) {
        item.imageUrl = `${$env.cdnUrl}/rsc/landitem/${item.filename}.png`
      }
      //- 期限つきアイテム
    } else if (type == 201) {
      item = useConsumableMaster().getLimitedItem(id)
      if (item) {
        item.imageUrl = `${$env.cdnUrl}/rsc/item/time_limited_item/${item.filename}.png`
      }
      //- 消費アイテム
    } else if (type == 202) {
      item = useConsumableMaster().getConsumeItem(id)

      if (item) {
        item.imageUrl = `${$env.cdnUrl}/rsc/item/consume_item/${item.filename}.png`
      }
      //- オーブ
    } else if (type == 203) {
      item = useConsumableMaster().getExtensionExpItem(id)
      if (item) {
        item.imageUrl = `${$env.cdnUrl}/rsc/item/extension_exp_item/${item.filename}.png`
      }
    } else if (type == 902) {
      item = UnitSummonItem[id]
      item.imageUrl = `${$env.cdnUrl}/rsc/item/offer_sale/unit_sale_item_${id}.png`
    // メモリア
    } else if (type = 301) {
      item = useMemoriaMaster().getMemoriaType(id)
      if (item.heroType) {
        item = useHeroMaster().getHeroType(item.heroType)
      }
    }

    return item
  })

  const getMode = computed(() => (i: any) => {
    let type = i.type || i.itemType
    let id = i.id || i.itemId

    if (type == 202) {
      if (id == constants.EXCHANGE_CONSUMEIDS.MintTicket) {
        return 'mintTicket'
      }

      if (id == constants.EXCHANGE_CONSUMEIDS.GachaCoin) {
        return 'gachaCoin'
      }

      if (id == constants.EXCHANGE_CONSUMEIDS.FrontierPoint) {
        return 'frontierPoint'
      }

      if (id == constants.EXCHANGE_CONSUMEIDS.SpecialMemoriaTicket) {
        return 'specialMemoriaTicket'
      }

      if (id == constants.EXCHANGE_CONSUMEIDS.SixHeroesGachaCoin) {
        return 'sixHeroesGachaCoin'
      }
    }
  })

  return {
    getReward,
    getMode,
  }
})
